const APPLICATION_PATH = '/mice';
const MICE_ASSET_PATH = '/corpmice';
const V2_ASSET_PATH = '/mybiz/';

const PAGE_URLS = {
	VENUES: APPLICATION_PATH + '/venues',
	MICE_PAGES: APPLICATION_PATH + '/:destinationType?/:eventType?/:city?/:property?'
};

const FQDNS = {
	CCB_URL: '//corpcb.makemytrip.com',
	SERVER_CCB_URL: 'http://corp-client-backend.prd.mmt.internal',
	MAPI_BASE_PATH: '//mapi.makemytrip.com',
	SERVER_POKUS: 'http://pokus.mmt.mmt',
	OCR_ENGINE: 'http://corp-ocr-engine.prd.mmt.internal'
};

const PATHS = {
	LANDING_PAGE: '/v2/',
	MMT_PATH: '//makemytrip.com',
	SIGNUP_PAGE: '/v2/signup',
	// OTHER PAGES
	BOOKING_SUMMARY: '//supportz.makemytrip.com/Mima/BookingSummary/',
	MY_PROFILE: '//www.makemytrip.com/my-profile/',
	FLIGHT_SEARCH_URL: 'https://www.makemytrip.com/flight/search?',
	CALL_SUPPORT_URL: 'https://support.makemytrip.com/?intid=Header_ch_support',
	MMT_MYBIZ: 'https://www.makemytrip.com?intid=FromMyBusiness',
	MYBIZ_URL: '//mybiz.makemytrip.com/v2/',
	MYBIZ_API_URL: '//mybiz.makemytrip.com',
	MMT_APP_LINK: 'http://applinks.makemytrip.com/SMsf/ss58WrOoaG',

	APP_SIGNUPLINK: 'https://applinks.makemytrip.com/mwebsignupmybiz',
	MMT_BIZ_PROFILE_URL: '//www.makemytrip.com/?isCorporate=true&isProfile=b2b',
	SEO_SCHEMA_URL: 'http://schema.org',
	MYBIZ_APP_DOWNLOAD: 'https://applinks.makemytrip.com/joinMyBiz?cmp=',
	RESOURCE_PAGE: '/v2/business-travel-on-myBiz',
	BASE_IMAGES_CDN_API: 'https://mybiz-img.mmtcdn.com/lobIcons/',
	SEND_ORG_FORM_DATA: '/internal/organization/add/details',
	/* ===== API URLS =====*/

	// COMMON APIS
	COMMON: {
		POKUS_API: FQDNS.MAPI_BASE_PATH + '/experiment/assignVariant',
		SERVER_POKUS: FQDNS.SERVER_POKUS + '/experiment/assignVariant',
		SERVER_LOG: APPLICATION_PATH + '/saveLogs',
		HEALTH_CHECK: APPLICATION_PATH + '/healthcheck'
	},

	LOGINBY_AUTH: '/loginByAuth',
	ACCESS_LOGS_PATH: '/opt/logs/access.log',
	CORP_USER_API: '/corp/user/employee',
	PROCESS_OCR: '/corp-apis/processOCR',
	API_HEALTH: '/corp-apis/health',
	OCR_ENGINE_API: FQDNS.OCR_ENGINE + '/corporate/parse/bulk/document',

	REQUEST_CALLBACK: {
		GET_REQUEST_CALLBACK: '/empeiria/cosmos/corporate/cards/requestCallback',
		GET_CALLBACK_SUPPORT: '/empeiria/cosmos/corporate/cards/callbackSupport'
	},
	BIZ_HEADER: {
		GET_PROFILE: '/v2/user/employee?needCompleteDetail=true'
	},
	// Mice Apis
	QUERY_FORM_REQUEST: '/mice/v1/data ',
	DESTINATION_SEARCH: '/mice/v1/destinations',
	VENUES: {
		SAVE_FORM: '/sendVenueData'
	}
};

const MICE_CONSTANTS = {
	PAGE_NAME: 'MICE_page',
	MICE_CLICKEVT: 'MICE_click',
	MONTH_FORMAT: 'MMMM YYYY',
	SHORT_MONTH_FORMAT: 'MMM\' YY',
	PROGRESS: 'progress',
	SUCCESS: 'success',
	HEADING: 'Tell Us Your Requirements',
	SUBHEADING: 'Just fill out the form, and our team of MICE booking experts will get back to you shortly with suitable options.',
	SUCCESS_HEADING: 'Request Submitted !',
	SUCCESS_DESC1: 'Our representative will contact you within 24 hours to confirm the appointment',
	SUCCESS_DES2: 'To change or cancel the appointment, please contact our customer care.',
	TOP_DESTINATION_CITY: 'Top Destinations',
	DEFAULT_CITY_LENGTH: 5,
	ERROR_HEADING: 'Request Not Submitted !'
};

const ORG_IMAGES_CONSTANT = {
	SECONDARY_ICON_OPACITY: '33',
	MYBIZ_DEFAULT_COLOR: '#FF664B',
	MYBIZ_DEFAULT_ICON_TYPE: 'png',
	MYBIZ_PNG_DENSITY: 300,
	S3_IMAGES_UPLOAD_TIMEOUT: 1000 * 5
};

const OCR_CONSTANTS = {
	DEFAULT_TIMEOUT: 60000,
	MAX_FILE_SIZE: 5 * 1024 * 1024,
	SUPPORTED_FORMATS: ['jpg', 'jpeg', 'png', 'pdf'],
	MAX_FILES_PER_REQUEST: 3,
	RATE_LIMIT_MSG: 'Rate limit exceeded. Too many requests.',
	ERROR_RESP_CODE: '800',
	FAILED: 'failed',
	NO_FILES_TXT: 'No files provided. Please upload files using the "files" field.',
	TOO_MANY_FILES_TXT: 'Too many files. Maximum 3 files allowed per request.',
	INVALID_REQ_TXT: 'Invalid request parameters',
	OCR_FAIL_TXT: 'OCR Processing failure',
	OCR_INTERNAL_ERR_TXT: 'Internal server error during OCR processing',
	FILE_UPLOAD_ERR_TXT: 'Error in file upload'
};

const APPLICATION_CONSTANTS = {
	SUCCESS_RESPONSE_CODE: '600',
	LINK_NAME: 'new_landing_page_click_tracker',
	DATE_FORMAT: 'YYYY/MM/DD',
	PARTIAL: 'PARTIAL_UPDATED',
	SUCCESS: 'SUCCESS',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
	PENDING: 'IN_PROGRESS',
	NOOP: 'NOOP',
	LOADING: 'LOADING',
	RUPEE: '₹',
	LINK_NAME: 'new_landing_page_click_tracker',
	pageTitle: `One Stop Solution for all your Corporate Group Travel Requirements.`,
	pageDesc: 'Plan your Business travel, company offsite or flights & Hotels for corporate traveler with GST compliant invoice. ✓ Free Registration ✓ Complimentary Meals ✓ 100% GST Invoice Assured Amenities: 100% GST Assured Invoice.',
	MYBIZ_MONGO_TEMPLATE: 'my_biz_template',
	POPUP: 'POPUP',
	OTHERS: 'OTHERS',
	CACHE_TIME: 8640
};

const BROWSER_URLS = {

};

const REGEX_PATTERNS = {
	MAXLEN: '^(?=.{len,})',
	GST_REGEX: /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1}[1-9a-zA-Z]{1})([A-Za-z]{1})([0-9a-zA-Z]{1})+$/,
	PAN_REGEX: /^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$/,
	DEF_PHONE_REGEX: /^(([0-9]{2})(\*{6}|[0-9]{6})[0-9]{2})$/i,
	PHONE_REGEX: /^(0|[1-9][0-9]{9})$/i,
	EMAIL_REGEX: /(?=^.{6,80}$)(^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$)/i,
	EXP_ID: /[a-z]\-[0-9]/i,
	AADHAR_REGEX: /^[0-9]{12}$/i,
	PASSPORT_REGEX: /^[A-PR-WYa-pr-wy][1-9][0-9]{5}[1-9]$/,
	BOOKID_REGEX: /[n]/i,
	FILE_CACHE: /(wishlist)|(EmpSharedOptions)|(expense)|(invoice)|(signupflow)|(PostLoggedin)|(shortlist)|(employee)|(group)|(wallet)|(policy)|(dashboard)|(provisional)|(reports)|(chartered)|(referadmin)|(referadmin)|(referCompany)|(train)|(triptag)/i,
	LOG_DATE_FORMATTER: /[A-Z]{3}\+/
};

const VENUES_CONSTANTS = {
	PAGE_NAME: 'venues_page',
	CLICKEVT: 'venues_click',
	MONTH_FORMAT: 'MMM YYYY'
};

module.exports = {
	APPLICATION_PATH,
	MICE_ASSET_PATH,
	PATHS,
	REGEX_PATTERNS,
	FQDNS,
	PAGE_URLS,
	APPLICATION_CONSTANTS,
	BROWSER_URLS,
	MICE_CONSTANTS,
	VENUES_CONSTANTS,
	V2_ASSET_PATH,
	ORG_IMAGES_CONSTANT,
	OCR_CONSTANTS
};
